
export const getClosestColorName = (r, g, b) => {
    const colors = [
        { name: "Black", r: 0, g: 0, b: 0 },
        { name: "White", r: 255, g: 255, b: 255 },
        { name: "Red", r: 255, g: 0, b: 0 },
        { name: "Green", r: 0, g: 255, b: 0 },
        { name: "Blue", r: 0, g: 0, b: 255 },
        { name: "Yellow", r: 255, g: 255, b: 0 },
        { name: "Cyan", r: 0, g: 255, b: 255 },
        { name: "Magenta", r: 255, g: 0, b: 255 },
        { name: "Gray", r: 128, g: 128, b: 128 },
        { name: "Orange", r: 255, g: 165, b: 0 },
        { name: "Brown", r: 165, g: 42, b: 42 },
        { name: "Pink", r: 255, g: 192, b: 203 },
        { name: "Purple", r: 128, g: 0, b: 128 },
        { name: "Navy", r: 0, g: 0, b: 128 },
        { name: "Gold", r: 255, g: 215, b: 0 },
        { name: "Silver", r: 192, g: 192, b: 192 },
        { name: "Olive", r: 128, g: 128, b: 0 },
        { name: "Maroon", r: 128, g: 0, b: 0 },
        { name: "Teal", r: 0, g: 128, b: 128 },
        { name: "Peach", r: 255, g: 218, b: 185 },
        { name: "Sky Blue", r: 135, g: 206, b: 235 },
        { name: "Cream", r: 255, g: 253, b: 208 },
        { name: "Beige", r: 245, g: 245, b: 220 },
        { name: "Lavender", r: 230, g: 230, b: 250 },
        { name: "Turquoise", r: 64, g: 224, b: 208 },
        { name: "Coral", r: 255, g: 127, b: 80 },
        { name: "Mint", r: 62, g: 180, b: 137 },
        { name: "Midnight Blue", r: 25, g: 25, b: 112 },
        { name: "Tan", r: 210, g: 180, b: 140 },
        { name: "Khaki", r: 240, g: 230, b: 140 },
        { name: "Indigo", r: 75, g: 0, b: 130 },
        { name: "Violet", r: 238, g: 130, b: 238 },
        { name: "Crimson", r: 220, g: 20, b: 60 },
        { name: "Plum", r: 221, g: 160, b: 221 }
    ];

    let minDistance = Infinity;
    let closestColor = "Unknown";

    colors.forEach(c => {
        const distance = Math.sqrt(
            Math.pow(r - c.r, 2) +
            Math.pow(g - c.g, 2) +
            Math.pow(b - c.b, 2)
        );
        if (distance < minDistance) {
            minDistance = distance;
            closestColor = c.name;
        }
    });

    return closestColor;
};

export const identifyAverageColor = (imageSource) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            let r = 0, g = 0, b = 0;
            const count = imageData.length / 4;

            for (let i = 0; i < imageData.length; i += 4) {
                r += imageData[i];
                g += imageData[i + 1];
                b += imageData[i + 2];
            }

            r = Math.floor(r / count);
            g = Math.floor(g / count);
            b = Math.floor(b / count);

            const name = getClosestColorName(r, g, b);
            resolve({ r, g, b, name });
        };
        img.onerror = () => resolve({ r: 0, g: 0, b: 0, name: "" });

        if (!imageSource.startsWith("data:") && !imageSource.startsWith("blob:")) {
            img.crossOrigin = "Anonymous";
        }
        img.src = imageSource;
    });
};
